module.exports = __webpack_public_path__ + "img/Final Model V5.5c37f265.jpg";